module.exports = __webpack_public_path__ + "img/Invasion-BRCA_GSE176078.e662c484.png";